// extracted by mini-css-extract-plugin
module.exports = {"base":"Separator_base__2kP0d"};